import { render, staticRenderFns } from "./AttendanceDashboardModal.vue?vue&type=template&id=4f157345"
import script from "./AttendanceDashboardModal.vue?vue&type=script&lang=js"
export * from "./AttendanceDashboardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports